<h2 mat-dialog-title>RETURN FRAMES</h2>
<mat-dialog-content>
  <table class="return-dialog-table">
    <thead>
      <tr>
        <th>Model</th>
        <th>Color</th>
        <th>Size</th>
        <th>Qty to return</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let line of lines">
        <td>{{ line.model }}</td>
        <td>{{ line.color }}</td>
        <td>{{ line.size }}</td>
        <td>
          <mat-form-field floatLabel="never" class="qty-field">
            <input
              matInput
              type="number"
              min="1"
              [max]="line.maxQuantity"
              [value]="line.returnQuantity"
              (input)="onQuantityChange(line, $any($event.target).value)"
            />
          </mat-form-field>
          <span class="max-qty">/ {{ line.maxQuantity }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">CANCEL</button>
  <button mat-raised-button color="primary" type="button" (click)="confirm()">
    RETURN FRAMES
  </button>
</mat-dialog-actions>
